import { render, staticRenderFns } from "./QuickLinks.vue?vue&type=template&id=a4cb6746&scoped=true"
import script from "./QuickLinks.vue?vue&type=script&lang=js"
export * from "./QuickLinks.vue?vue&type=script&lang=js"
import style0 from "./QuickLinks.vue?vue&type=style&index=0&id=a4cb6746&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4cb6746",
  null
  
)

export default component.exports